import {connect} from 'react-redux';
import {Plant as Component} from './Plant';
import {
  pushInteractions,
  createPlant,
  setHeldObject,
  setHeld,
  setPlantsInScene,
  setPlantHeld,
  setPlantControlVisibility,
  hideAllControls,
  glassTubeItemDrop,
} from '@learningblocks/protocol-redux/lib/Actions';

function mapStateToProps(state, ownProps) {

  if(state.notebook.protocolSection.scene.apparatus.hasOwnProperty("plants") &&
     state.notebook.protocolSection.scene.apparatus.plants.some(
       plant => plant.id === ownProps.id
     )
  ){
    return {
      id: ownProps.id,
      type: state.notebook.protocolSection.scene.apparatus.plants[ownProps.id-1].type,
      controlsVisible: state.notebook.protocolSection.scene.apparatus.plants[ownProps.id - 1].controlsVisible,

      lastDrop: state.notebook.protocolSection.scene.lastDrop,
      heldObject: state.notebook.protocolSection.scene.heldObject,
      inScene: state.notebook.protocolSection.scene.apparatus.plants[ownProps.id-1].inScene,
      interactionProps: {
        glassTubes: state.notebook.protocolSection.scene.apparatus.glassTubes,
      },
    }
  } else {
    return {}
  }
}

function mapDispatchToProps(dispatch) {
  return {
    createPlant: (data)=>{
      dispatch(createPlant(data))
    },
    setPlantControlVisibility: (data) => {
      dispatch(setPlantControlVisibility(data))
    },
    setPlantsInScene: (data) => {
      dispatch(setPlantsInScene(data))
    },
    hideAllControls: (data) => {
      dispatch(hideAllControls(data))
    },
    setHeld: (data) => {
      dispatch(setHeld(data))
    },
    setPlantHeld: (data) => {
      dispatch(setPlantHeld(data))
    },
    setHeldObject: (data) => {
      dispatch(setHeldObject(data))
    },
    onDropPlant: (data)=>{
      dispatch(glassTubeItemDrop(data))
    },
    pushInteractions: (data) => {
      dispatch(pushInteractions(data))
    },
  
  };
}

export const Plant = connect(
  mapStateToProps,
  mapDispatchToProps
)(Component);
